/* Copyright (c) 2023 CLOUDPILOTS Software & Consulting GmbH */

import { lazy } from 'react';

const load = (imp) => lazy(() => imp);

const pages = {
  Dashboard: import(
    /* webpackChunkName: "pages.home" */
    'pages/Dashboard'
  ),
  Customers: import(
    /* webpackChunkName: "pages.customers" */
    'pages/customers/Customers'
  ),
  CustomersView: import(
    /* webpackChunkName: "pages.customers" */
    'pages/customers/view'
  ),
  CustomersPriceView: import(
    /* webpackChunkName: "pages.customers" */
    'pages/customers/prices/view'
  ),
  CustomersInvoiceView: import(
    /* webpackChunkName: "pages.customers" */
    'pages/customers/invoices/view'
  ),
  CustomersPlanView: import(
    /* webpackChunkName: "pages.customers" */
    'pages/customers/plans/view'
  ),
  Subscriptions: import(
    /* webpackChunkName: "pages.subscriptions" */
    'pages/subscriptions/Subscriptions'
  ),
  SubscriptionsView: import(
    /* webpackChunkName: "pages.subscriptions" */
    'pages/subscriptions/view'
  ),
  Prices: import(
    /* webpackChunkName: "pages.prices" */
    'pages/prices/Prices'
  ),
  PricesView: import(
    /* webpackChunkName: "pages.prices" */
    'pages/prices/view/view'
  ),
  Plans: import(
    /* webpackChunkName: "pages.plans" */
    'pages/plans/Plans'
  ),
  PlansView: import(
    /* webpackChunkName: "pages.plans" */
    'pages/plans/view'
  ),
  Billing: import(
    /* webpackChunkName: "pages.billing" */
    'pages/billing'
  ),
  Invoices: import(
    /* webpackChunkName: "pages.billing" */
    'pages/invoices/invoices'
  ),
  InvoicesView: import(
    /* webpackChunkName: "pages.billing" */
    'pages/invoices/view'
  ),
  InvoiceImports: import(
    /* webpackChunkName: "pages.billing" */
    'pages/invoiceImports/invoice-imports'
  ),
  InvoiceImportsView: import(
    /* webpackChunkName: "pages.billing" */
    'pages/invoiceImports/view'
  ),
};

// TODO Check the duplicate ids
const routes = [
  {
    id: 'customers',
    handler: load(pages.Customers),
    path: '/customers',
    exact: true,
    props: {
      slug: 'customers',
    },
  },
  {
    id: 'customers',
    handler: load(pages.CustomersPriceView),
    path: '/customers/:id/prices/:priceId',
    exact: true,
    props: {
      slug: 'customers',
    },
  },
  {
    id: 'customers',
    handler: load(pages.CustomersInvoiceView),
    path: '/customers/:id/invoices/:invoiceId',
    exact: true,
    props: {
      slug: 'customers',
    },
  },
  {
    id: 'customers',
    handler: load(pages.CustomersPlanView),
    path: '/customers/:id/plans/:planId',
    exact: true,
    props: {
      slug: 'customers',
    },
  },
  {
    id: 'customers',
    handler: load(pages.CustomersView),
    path: '/customers/:id',
    exact: true,
    props: {
      slug: 'customers',
    },
  },
  {
    id: 'customers',
    handler: load(pages.CustomersMissing),
    path: '/customers/missing',
    exact: true,
    props: {
      slug: 'customers',
    },
  },
  {
    id: 'subscriptions',
    handler: load(pages.Subscriptions),
    path: '/subscriptions',
    exact: true,
    props: {
      slug: 'subscriptions',
      button: true,
      dialog: {
        subtitle: 'New subscription',
        button: 'Create',
      },
    },
  },
  {
    id: 'subscriptions',
    handler: load(pages.SubscriptionsView),
    path: '/subscriptions/:id/view',
    exact: true,
    props: {
      slug: 'subscriptions',
    },
  },

  {
    id: 'people',
    handler: load(pages.PeopleView),
    path: '/people/:id/view',
    exact: true,
    props: {
      slug: 'people',
    },
  },

  {
    id: 'prices',
    handler: load(pages.Prices),
    path: '/prices',
    exact: true,
    props: {
      slug: 'prices',
      button: true,
      dialog: {
        subtitle: 'New prices',
        button: 'Create',
      },
    },
  },
  {
    id: 'prices',
    handler: load(pages.PricesView),
    path: '/prices/:id/view',
    exact: true,
    props: {
      slug: 'prices',
    },
  },
  {
    id: 'plans',
    handler: load(pages.Plans),
    path: '/plans',
    exact: true,
    props: {
      slug: 'plans',
    },
  },
  {
    id: 'plans',
    handler: load(pages.PlansView),
    path: '/plans/:id/view',
    exact: true,
    props: {
      slug: 'plans',
    },
  },
  {
    id: 'billing',
    handler: load(pages.Billing),
    path: '/billing',
    exact: true,
    props: {
      slug: 'billing',
    },
  },
  {
    id: 'invoices',
    handler: load(pages.Invoices),
    path: '/invoices',
    exact: true,
    props: {
      slug: 'invoices',
    },
  },
  {
    id: 'invoicesView',
    handler: load(pages.InvoicesView),
    path: '/customers/:customerId/invoices/:invoiceId/view',
    exact: true,
    props: {
      slug: 'invoices',
    },
  },
  {
    id: 'invoiceImports',
    handler: load(pages.InvoiceImports),
    path: '/invoiceImports',
    exact: true,
    props: {
      slug: 'invoiceImports',
    },
  },
  {
    id: 'invoiceImports',
    handler: load(pages.InvoiceImportsView),
    path: '/invoiceImports/:id/view',
    exact: true,
    props: {
      slug: 'invoiceImports',
    },
  },
  {
    id: 'dashboard',
    handler: load(pages.Dashboard),
    path: '/',
    exact: true,
  },
];

export { routes as default };
